import { brand } from "@/data/site";

export default function About() {
    return (
        <div data-testid="page-about" className="wx-container py-10">
            <h1 className="text-2xl font-semibold text-[color:var(--wx-ink)] tracking-tight">
                Tentang Kami
            </h1>

            <div className="mt-5 space-y-4 text-sm text-[color:var(--wx-ink2)] leading-relaxed">
                <p>
                    <span className="font-semibold text-[color:var(--wx-ink)]">
                        {brand.name}
                    </span>{" "}
                    merupakan layanan Jastip & PO Luar Negeri yang telah
                    dipercaya sejak 2024. Kami membantu customer di seluruh
                    Indonesia mendapatkan berbagai produk fashion, elektronik,
                    snack, dan skincare melalui layanan jastip dan live shopping
                    dari Bangkok dan Guangzhou dengan harga terbaik.
                </p>

                <p>
                    WxFaous dioperasikan oleh{" "}
                    <span className="font-semibold text-[color:var(--wx-ink)]">
                        {brand.legal}
                    </span>
                    . Pemesanan dilakukan melalui WhatsApp dan customer dapat
                    memantau status pesanan melalui sistem WxFaous.
                </p>

                <p>
                    Informasi perusahaan, kontak, dan layanan pada website ini
                    dikelola oleh {brand.legal}.
                </p>

                <p className="pt-2 text-xs text-[color:var(--wx-muted)]">
                    {brand.name} is operated by {brand.legal}.
                </p>
            </div>
        </div>
    );
}